import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import ReviewForm from "@/components/ReviewForm";

export default function Review() {
  const navigate = useNavigate();
  return (
    <main data-testid="review-page">
      <PageHeader
        center
        overline="Leave a Review"
        title="Share your"
        accent="story."
        description="Celebrated with Dream Entertainment? Tell everyone how it went. Your review appears on our website the moment you post it."
      />
      <section className="max-w-3xl mx-auto px-6 sm:px-12 pb-24">
        <Reveal>
          <ReviewForm
            onSubmitted={() => setTimeout(() => navigate("/testimonials"), 1500)}
          />
        </Reveal>
      </section>
    </main>
  );
}
